import React, { useEffect } from 'react';
// Interface
import { useDispatch, useSelector } from 'react-redux';
// Redux
import {
  Grid,
} from '@material-ui/core';
import { RootState } from '../../../../redux/store';
import {
  getSubjectsByCourseIdThunk,
} from '../../../../redux/ducks/SubjectDucks';
import {
  actions as actionsTeachers,
} from '../../../../redux/ducks/TeacherDucks';
import {
  actions as actionsBooks,
} from '../../../../redux/ducks/BookDucks';
// Components
import Breadcrumbs from '../../../../components/Breadcrumbs/Breadcrumbs';
// eslint-disable-next-line max-len
import ContainerBreadcrumbs from '../../../../components/ContainerBreadcrumbs/ContainerBreadcrumbs';
import SubjectItem from '../../../../components/SubjectStudentItem/SubjectStudentItem';
import MessageCard from '../../../../components/MessageCard/MessageCard';
import Spinner from '../../../../components/Spinner/Spinner';

const AllMySubjects: React.FC = () => {
  const dispatch = useDispatch();
  const { userData } = useSelector((
    state: RootState,
  ) => state.login );

  const { subjects, loading } = useSelector(( state: RootState ) => state.subject );

  useEffect(() => {
    dispatch( actionsTeachers.getTeachers());
    dispatch( actionsBooks.getBooks());
    dispatch( getSubjectsByCourseIdThunk( userData.courseId ));
  }, []);

  return (
    <>
      <ContainerBreadcrumbs>
        <Breadcrumbs
          back={false}
          itemsLinks={[{ name: 'Materias', url: 'estudiante/materias' }]}
          itemsText={['Todas tus materias']}
        />
      </ContainerBreadcrumbs>
      <Grid container spacing={4} direction="row" justify="center">
        {loading ? (
          <Spinner />
        ) : (
          <>
            {subjects && subjects.length > 0 ? (
              <>
                {subjects
            && subjects.map(( subject ) => (
              <Grid item xs={12} sm={5} md={4} key={subject.id}>
                <SubjectItem subject={subject} />
              </Grid>
            ))}
              </>
            ) : (
              <MessageCard>
                <h3>No hay materias asignadas.</h3>
              </MessageCard>
            )}
          </>
        )}
      </Grid>
    </>
  );
};

export default AllMySubjects;
